import { useState } from "react";
import { useAuth } from "hooks/useAuth"; // adjust the path if needed
import { useNavigate } from "react-router-dom";
import singin_bg from "assets/signin_bg.png";

const LoginForm = () => {
  const { login, isAuthLoading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err: any) {
      setError(err.message || "Login failed");
    }
  };

  return (
    <div className="flex items-center justify-center h-full w-full">
      <form
        onSubmit={handleSubmit}
        className="p-8 rounded shadow-md w-[26%] h-[75%] flex items-start justify-center"
        style={{
          backgroundImage: `url(${singin_bg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      >
        <div className="w-full">
          <div className="mb-10">
            <h2 className="text-3xl font-bold mb-6 text-left">Sign in</h2>

            {error && <p className="text-red-500 mb-4">{error}</p>}

            <label className="block mb-2 font-medium text-lg">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="!appearance-none border !border-green w-full p-2 mb-4 rounded !text-white bg-blue/50 focus:outline-none"
            />

            <label className="block mb-2 font-medium text-lg">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="!appearance-none border border-green w-full p-2 mb-4 rounded text-white bg-blue/50 focus:outline-none"
            />
          </div>

          <button
            type="submit"
            disabled={isAuthLoading}
            className="w-full bg-blue-600 text-lg text-white gradient py-2 rounded-sm hover:bg-blue-700 transition"
          >
            {isAuthLoading ? "Logging in..." : "Login"}
          </button>
        </div>
      </form >
    </div >
  );
};

export default LoginForm;